const removeTrailingSlash = url => url.replace(/\/$/, '');
export default removeTrailingSlash;